<template lang="pug">
  DataTablePage(
    mainColumn="name"
    longColumn="workDate"
    relation="true"
    resource="meterReading/schedule/read"
    title="抄表记录"
    label="抄表记录"
    labelName="loginName"
    :operation="operation"
    :operationWidth="113"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :columns="columns")
    SmartDialog(
      v-model="dialogVisible"
      :title="dialogTitle"
      :size="dialogSize")
      TrackMap(
        v-if="dialogName === 'track' && dialogVisible"
        :resource="trackResource")
      //- TrackTable(
      //-   v-if="dialogName === 'detail' && dialogVisible"
      //-   :resource="trackResource")
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import fullColumns from '@/containers/meterReading/fullColumns'
import SmartDialog from '@/components/SmartDialog'
import TrackMap from '@/containers/meterReading/Track/TrackMap'
import moment from 'moment'
// import TrackTable from '@/containers/meterReading/Track/TrackTable'

export default {
  name: 'record',
  components: {
    DataTablePage,
    SmartDialog,
    TrackMap
    // TrackTable
  },
  data () {
    return {
      dialogName: '',
      dialogTitle: '',
      dialogSize: 'lg',
      dialogShow: false,
      dialogVisible: false,
      trackResource: '',
      operation: [{
        name: 'track',
        label: '抄表轨迹',
        icon: 'mark',
        tooltip: true,
        func: (full) => {
          console.log(full.funcProps)
          const { button, data } = full.funcProps
          this.dialogName = button.name
          this.dialogTitle = `【${data.areaCode}区${data.bookCode}】${moment(data.workDate).format('YYYY-MM-DD')} ${button.label}`
          this.dialogVisible = true
          this.trackResource = `meterReading/readingData/${data.id}`
        }
      }, {
        name: 'detail',
        label: '抄表详情',
        icon: 'info',
        tooltip: true,
        func: (data) => {
          const { funcProps } = data
          this.$router.push(`/meterReading/track/${funcProps.data.id}`)
          // this.dialogName = funcProps.button.name
          // this.dialogTitle = funcProps.button.label
          // this.dialogVisible = true
          // this.trackResource = `meterReading/readingData/${funcProps.data.id}`
        }
      }],
      tableInitList: ['orgParentId', 'orgId', 'readingUserId', 'areaCode', 'bookCode', 'workDate', 'readingEndTime', 'needReadingNumPre', 'needReadingNum', 'waterUserNumChangeRate', 'waterUsePre', 'abnormalWaterUserNum', 'waterUseNow', 'normalWaterUser', 'waterUseNumChangeRate', 'avgReadingTime'],
      tableFullList: ['orgParentId', 'orgId', 'readingUserId', 'areaCode', 'bookCode', 'workDate', 'readingEndTime', 'needReadingNumPre', 'needReadingNum', 'waterUserNumChangeRate', 'waterUsePre', 'abnormalWaterUserNum', 'waterUseNow', 'normalWaterUser', 'waterUseNumChangeRate', 'avgReadingTime'],
      filterInitList: [],
      filterFullList: [],
      columns: {
        ...fullColumns,
        workDate: {
          label: '计划抄表日期',
          width: 130,
          type: 'time',
          style: {
            textAlign: 'center'
          },
          dateType: 'YYYY-MM-DD'
        },
        readingEndTime: {
          label: '实际完成日期',
          width: 130,
          style: {
            textAlign: 'center'
          },
          type: 'time',
          dateType: 'YYYY-MM-DD HH:mm:ss'
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// index.vue?01709e45